import { LAYOUT } from '@admin/router/constant'

// 物料开发单
const flowerDraftDevelopmentFormRouter = {
  path: '/flowerDraftDevelopmentForm',
  name: '',
  component: LAYOUT,
  children: [
    {
      path: '/flower-draft-development-form/index',
      name: 'flowerDraftDevelopmentFormList',
      component: () => import('@admin/views/plm/flowerDraftDevelopmentForm/index/index.vue'),
      meta: { helpUrl: '', title: '花稿开发单' },
    },
    {
      path: '/flower-draft-development-form/detail',
      name: 'flowerDraftDevelopmentFormDetail',
      component: () => import('@admin/views/plm/newDesign/detail/index.vue'),
      meta: { helpUrl: '', title: '花稿开发详情' },
    },
  ],
}

export default flowerDraftDevelopmentFormRouter
